import { render, staticRenderFns } from "./AppPageContainer.vue?vue&type=template&id=48a6f2b5&scoped=true&"
import script from "./AppPageContainer.vue?vue&type=script&lang=js&"
export * from "./AppPageContainer.vue?vue&type=script&lang=js&"
import style0 from "./AppPageContainer.vue?vue&type=style&index=0&id=48a6f2b5&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a6f2b5",
  null
  
)

export default component.exports